import { NewtopiaBottomCards, NewtopiaMarketCard, NewtopiaTopCards } from './NewtopiaCards';

export const ForBigDesktops = () => {
	return (
		<div className='newtopiaLarge'>
			<div className='newtopiaLarge__cardContainer'>
				<NewtopiaTopCards className='cardDesktop cardTopContainer' />
				<NewtopiaBottomCards className='cardDesktop cardBottomContainer' />
				<NewtopiaMarketCard
					wrapperClassName='cardDesktop cardLeftContainer'
					cardClassName='cardNewtoMarket'
				/>
				<div className='newtopiawave'></div>
			</div>
		</div>
	);
};
